<template>
  <el-dialog
    :title="id==0 ? '添加今日灵修' : '编辑今日灵修'"
    :visible.sync="visible"
    :before-close="closeDialog"
    @closed="closeDialog"
    width="40%"
    @opened="addOpen"
    :close-on-click-modal="false">
    <el-form :model="formData" :rules="formRules" ref="formRef" label-width="80px">
      <el-form-item label="日期" prop="day_time">
        <el-date-picker v-model="formData.day_time" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
      </el-form-item>
      <el-form-item label="栏目" prop="group_id">
        <el-select v-model="formData.group_id" placeholder="请选择栏目" filterable @change="getCategoryList">
          <el-option label="请选择栏目" :value="0"></el-option>
          <el-option v-for="item in groupList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="讲员" prop="speaker_id">
        <el-select v-model="formData.speaker_id" placeholder="请选择讲员" filterable @change="getCategoryList">
          <el-option label="请选择讲员" :value="0"></el-option>
          <el-option v-for="item in speakerList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="专辑" prop="category_id">
        <el-select v-model="formData.category_id" placeholder="请选择专辑名称" filterable @change="categoryChange">
          <el-option label="请选择专辑" :value="0"></el-option>
          <el-option v-for="item in categoryList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="内容" prop="content_id">
        <el-select v-model="formData.content_id" placeholder="请选择内容" filterable>
          <el-option label="请选择内容" :value="0"></el-option>
          <el-option v-for="item in contentList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="循环" prop="cycle">
        <el-select v-model="formData.cycle" placeholder="请选择循环类型" filterable>
          <el-option v-for="item in cycleList" :key="item.id" :label="item.title" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="封面" prop="pic">
        <template>
          <el-upload
            class="avatar-uploader"
            action="/proxy/admin/upload_img"
            name="img"
            :show-file-list="false"
            :on-success="handleSuccess">
            <img v-if="imageUrl" :src="imageUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </template>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="addConfirm" :disabled="confirmDisable">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'practice_day_add',
  props: [
    'visible', 'id', 'groupList', 'speakerList', 'cycleList'
  ],
  data () {
    return {
      formData: {
        day_time: '',
        pic: '',
        group_id: 0,
        speaker_id: 0,
        category_id: 0,
        content_id: 0,
        cycle: 0
      },
      confirmDisable: false,
      categoryList: [],
      contentList: [],
      imageUrl: '',
      formRules: {
        content_id: [
          { required: true, message: '内容不能为空', trigger: 'blur' }
        ],
        day_time: [
          { required: true, message: '日期不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    closeDialog () {
      this.$refs.formRef.resetFields()
      this.imageUrl = ''
      this.$emit('close')
    },
    addConfirm () {
      this.$refs.formRef.validate(valid => {
        if (!valid) return
        // 验证通过
        this.confirmDisable = true
        if (this.id === 0) {
          this.$emit('add', this.formData)
        } else {
          this.$emit('update', this.id, this.formData)
        }
      })
    },
    addOpen () {
      // 如果id>0,则是编辑信息
      if (this.id > 0) {
        this.getInfo(this.id)
      }
      this.confirmDisable = false
    },
    handleSuccess (resp, file, fileList) {
      if (resp.code === 0) {
        this.imageUrl = resp.data.url
        this.formData.pic = resp.data.path
      } else {
        this.$message.error(resp.msg)
      }
    },
    async getCategoryList () {
      if (this.formData.group_id === 0 || this.formData.speaker_id === 0) {
        this.categoryList = []
        this.formData.category_id = 0
        return
      }
      const res = await this.$http.get('/admin/category/select_list', this.formData)
      if (res.code === 0) {
        this.categoryList = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    categoryChange () {
      this.getContentList()
      this.getCategoryInfo(this.formData.category_id)
    },
    async getContentList () {
      if (this.formData.category_id === 0) {
        this.contentList = []
        this.formData.content_id = 0
        return
      }
      const res = await this.$http.get('/admin/content/select_list', this.formData)
      if (res.code === 0) {
        this.contentList = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    async getCategoryInfo (id) {
      const res = await this.$http.get('/admin/category/info/' + id)
      if (res.code === 0) {
        this.formData.pic = res.data.pic
        this.imageUrl = res.data.pic_url
      }
    },
    async getInfo (id) {
      const res = await this.$http.get('/admin/spiritual_practice_day/info/' + id)
      if (res.code === 0) {
        this.formData = {
          day_time: res.data.day_time_str,
          group_id: res.data.group_id,
          category_id: res.data.category_id,
          speaker_id: res.data.speaker_id,
          content_id: res.data.content_id,
          cycle: res.data.cycle,
          pic: res.data.pic
        }
        this.imageUrl = res.data.pic_url
        this.getCategoryList()
        this.getContentList()
      }
    }
  }
}
</script>

<style>
</style>
